import { PAGE_PERMISSION, canAccessPermissions } from '@/config/permissions.js'
import { isManager } from '@/utils/auth.js'

export default {
  namespaced: true,
  state: {
    pageKeys: [],
    actionKeys: [],
    loaded: false,
    loadingPromise: null,
  },
  mutations: {
    setPageKeys(state, keys) {
      state.pageKeys = Array.from(new Set(keys || []))
      if (!state.pageKeys.includes(PAGE_PERMISSION.PLATFORM_OVERVIEW)) {
        state.pageKeys.unshift(PAGE_PERMISSION.PLATFORM_OVERVIEW)
      }
      state.loaded = true
    },
    setActionKeys(state, keys) {
      state.actionKeys = Array.from(new Set(keys || []))
    },
    setLoadingPromise(state, promise) {
      state.loadingPromise = promise
    },
    reset(state) {
      state.pageKeys = []
      state.actionKeys = []
      state.loaded = false
      state.loadingPromise = null
    },
  },
  actions: {
    setFromLogin({ commit }, payload) {
      const normalized = Array.isArray(payload) ? { pageKeys: payload } : (payload || {})
      commit('setPageKeys', normalized.pageKeys || [])
      commit('setActionKeys', normalized.actionKeys || [])
    },
    ensureLoaded({ state, commit }, force = false) {
      if (state.loaded && !force) return Promise.resolve(state.pageKeys)
      if (state.loadingPromise && !force) return state.loadingPromise

      const promise = import('@/api/system.js')
        .then(({ getCurrentPagePermissions }) => getCurrentPagePermissions())
        .then((res) => {
          const keys = (res.data && res.data.page_keys) || []
          const actionKeys = (res.data && res.data.action_keys) || []
          commit('setPageKeys', keys)
          commit('setActionKeys', actionKeys)
          return { pageKeys: keys, actionKeys }
        })
        .finally(() => commit('setLoadingPromise', null))
      commit('setLoadingPromise', promise)
      return promise
    },
    refresh({ dispatch }) {
      return dispatch('ensureLoaded', true)
    },
    reset({ commit }) {
      commit('reset')
    },
  },
  getters: {
    hasAny: (state) => (requiredKeys) => canAccessPermissions(state.pageKeys, requiredKeys),
    // 后端的权限模型中，admin / super_admin 隐式拥有全部操作权限。
    // Vuex 在页面刷新后会先恢复为空状态，不能因此把管理身份的按钮误判为无权限。
    hasAction: (state) => (actionKey) => isManager() || state.actionKeys.includes(actionKey),
  },
}
